import React, { useEffect, useState } from "react";
import AddTitleBar from "../../components/titleBar/add_titleBar";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import moment from "moment";
import {
    Form as FormUi,
    Container,
    TextArea,
    Button,
    Input,
    Segment,
    Dropdown,
    Icon,
    Search,
} from "semantic-ui-react";
import DatePicker from "react-datepicker";
import MandatoryMark from "../../components/common/mandatorymark";
import { MyNormalInput, MyInput, MyTextArea, MyNumInput } from '../../components/dynamicComponent/myInputs'
import AddCity from "../../components/dynamicComponent/addCity";
import MyState from "../../components/apiInputs/myState";
import ReadAxios from "../../components/axiosComponent/read";
import Axios from "axios";
import { LOCAL_STORAGE } from '../../utils/constant'
import { isEmpty, values } from "lodash";
import { AllRegex } from '../../utils/validation'
import { INVALID_FIELDS, REQUIRED_FIELDS } from '../../utils/validationConstant'
import cogoToast from "cogo-toast";
import MyConsigneeMaster from "../../components/apiInputs/consigneeMaster";
import MyConsignorMaster from "../../components/apiInputs/consignorMaster";
import MySkuCode from "../../components/apiInputs/skuCodeDropdown";
import MyTransporterMaster from "../../components/apiInputs/transporterDropdown";
import MyVehicleMaster from "../../components/apiInputs/vehicleNumberDropdown";
import SearchDropdownVehicle from '../../components/createShipmentComponent/searchDropdownVehicle'

const AddEwayBill = ({
    setFieldValue,
    values,
    touched,
    errors,
    handleSubmit,
    ...props
}) => {
    const [supplyTypes, setSupplyTypes] = useState([])
    const [subSupplyTypes, setSubSupplyTypes] = useState([])
    const [docTypes, setDocTypes] = useState([])
    const [measurementUnits, setMeasurementUnits] = useState([])
    const [transactionTypes, setTransactionTypes] = useState([])
    const [vehicleTypes, setVehicleTypes] = useState([])
    const [transModes, setTransModes] = useState([])

    useEffect(() => {
        getSupplyTypes()
        getMeasurementUnits()
        getTransactionTypes()
        getVehicleTypes()
        getVendorDetails()
        getTransportationModes()
        getProductDetails()
    }, [])

    useEffect(() => {
        getSubSupplyTypes()
    }, [values.supply_type])

    useEffect(() => {
        getDocumentTypes()
    }, [values.supply_type, values.sub_supply_type])

    const Headers = { headers: { 'content-type': 'application/json', 'Authorization': `${LOCAL_STORAGE.userToken}` } }
    const bodyData = JSON.stringify
        ({
            customerNo: LOCAL_STORAGE.customerNo,
            userId: LOCAL_STORAGE.userId
        })
    const getSupplyTypes = () => {
        Axios.post(`${process.env.REACT_APP_EWAY_BILL_MASTER}/getSupplyType`, bodyData, Headers).then((response) => {
            let dataArray = isEmpty(response) ? [] : response.data.data;
            setSupplyTypes(
                dataArray.map((item, index) => {
                    return {
                        raw: { ...item },
                        index,
                        text: item.supplyTypeName,
                        key: item.supplyTypeId,
                        value: item.supplyTypeCode,
                    };
                })
            );
        }).catch((err) => {
            console.log(err);
        })
    }

    const getTransportationModes = ()=>{
    Axios.post(`${process.env.REACT_APP_EWAY_BILL_MASTER}/getTransportationMode`, bodyData, Headers).then((response) => {
        let dataArray = isEmpty(response) ? [] : response.data.data;
        setTransModes(
            dataArray.map((item, index) => {
                return {
                    raw: { ...item },
                    index,
                    text: item.transportationModeName,
                    key: item.transportationModeId,
                    value: item.transportationModeCode,
                };
            })
        );
    }).catch((err) => {
        console.log(err);
    })
    }

    const getSubSupplyTypes = () => {
        const Data = JSON.stringify
            ({
                customerNo: LOCAL_STORAGE.customerNo,
                supplyTypeId: values.supply_type_id
            })
        Axios.post(`${process.env.REACT_APP_EWAY_BILL_MASTER}/getSubSupplyType`, Data, Headers).then((response) => {
            let dataArray = isEmpty(response) ? [] : response.data.data;
            setSubSupplyTypes(
                dataArray.map((item, index) => {
                    return {
                        raw: { ...item },
                        index,
                        text: item.subSupplyTypeName,
                        key: item.subSupplyTypeId,
                        value: item.subSupplyTypeId,
                    };
                })
            );
        }).catch((err) => {
            console.log(err);
        })
    }

    const getDocumentTypes = () => {
        const Data = JSON.stringify
            ({
                customerNo: LOCAL_STORAGE.customerNo,
                supplyTypeId: values.supply_type_id,
                subSupplyTypeId: values.sub_supply_type
            })
        Axios.post(`${process.env.REACT_APP_EWAY_BILL_MASTER}/getDocumentType`, Data, Headers).then((response) => {
            let dataArray = isEmpty(response) ? [] : response.data.data;
            setDocTypes(
                dataArray.map((item, index) => {
                    return {
                        raw: { ...item },
                        index,
                        text: item.documentTypeName,
                        key: item.documentTypeId,
                        value: item.documentTypeCode,
                    };
                })
            );
        }).catch((err) => {
            console.log(err);
        })
    }

    const getMeasurementUnits = () => {
        Axios.post(`${process.env.REACT_APP_EWAY_BILL_MASTER}/getUnitOfMeasurement`, bodyData, Headers).then((response) => {
            let dataArray = isEmpty(response) ? [] : response.data.data;
            setMeasurementUnits(
                dataArray.map((item, index) => {
                    return {
                        raw: { ...item },
                        index,
                        text: item.unitOfMeasurementName,
                        key: item.unitOfMeasurementId,
                        value: item.unitOfMeasurementId,
                    };
                })
            );
        }).catch((err) => {
            console.log(err);
        })
    }

    const getTransactionTypes = () => {
        Axios.post(`${process.env.REACT_APP_EWAY_BILL_MASTER}/getTransactionType`, bodyData, Headers).then((response) => {
            let dataArray = isEmpty(response) ? [] : response.data.data;
            setTransactionTypes(
                dataArray.map((item, index) => {
                    return {
                        raw: { ...item },
                        index,
                        text: item.transactionTypeName,
                        key: item.transactionTypeId,
                        value: item.transactionTypeId,
                    };
                })
            );
        }).catch((err) => {
            console.log(err);
        })
    }

    const getVehicleTypes = () => {
        Axios.post(`${process.env.REACT_APP_EWAY_BILL_MASTER}/getVehicleType`, bodyData, Headers).then((response) => {
            let dataArray = isEmpty(response) ? [] : response.data.data;
            setVehicleTypes(
                dataArray.map((item, index) => {
                    return {
                        raw: { ...item },
                        index,
                        text: item.vehicleTypeName,
                        key: item.vehicleTypeId,
                        value: item.vehicleTypeCode,
                    };
                })
            );
        }).catch((err) => {
            console.log(err);
        })
    }

    const setUnitOfMeasurement = (value, index) => {
        setFieldValue(`products[${index}].qty_unit_id`, value)
        const unitDetails = measurementUnits.find((unit) => unit.value === value)
        if (unitDetails) setFieldValue(`products[${index}].qty_unit_name`, unitDetails.text)
    }

    const onChangeProducts = (event, values, name, setValues) => {
        event.preventDefault();
        event.stopPropagation();

        // update dynamic form
        const products = [...values.products];
        const previousNumber = values.numberOfProducts;

        values.numberOfProducts += 1;

        const numberOfProducts = values.numberOfProducts;

        if (previousNumber < numberOfProducts) {
            for (let i = previousNumber; i < numberOfProducts; i++) {
                let productsAddList = getProductsArray(values);
                products.push(productsAddList);
            }
        } else {
            for (let i = previousNumber; i >= numberOfProducts; i--) {
                products.splice(i, 1);
            }
        }

        setValues(name, products);
    }

    const getProductsArray = (values) => {
        return {
            hsn_code: '',
            product_name: '',
            product_description: '',
            quantity: '',
            qty_unit_id: '',
            cgst_rate: '',
            sgst_rate: '',
            igst_rate: '',
            cess_rate: '',
            cess_advol: '',
            taxable_amount: '',
        }
    }

    const onChangeProductsRemove = (values, name, setValues, index) => {
        // update dynamic form
        const products = [...values.products];
        products.splice(index, 1);

        setValues(name, products);
    }

    const getVendorDetails = () => {
        if (props.history?.location?.state?.delivery?.order?.vendor_id) {
            let vendorId = props.history?.location?.state?.delivery?.order?.vendor_id

            ReadAxios({ url: `/transporterMaster/${vendorId}` }).then((res) => {
                setFieldValue('transporter_name', res.data.resultSet[0].transporterName)
            }).catch((err) => {
                console.log(err);
            })
        }
    }

    const setSupplyTypeValue = (data) => {
        setFieldValue('supply_type', data.value)
       let currentSupplyType =  data.options.find((option) => option.value===data.value)
       if(currentSupplyType) setFieldValue('supply_type_id', currentSupplyType.key)
       setFieldValue('sub_supply_type', "")
       setFieldValue('doc_type', "")
    }

    const getProductDetails = ()=> {
        if (props.history?.location?.state?.products) {
            let products = props.history?.location?.state?.products
              let productArray = [] , productObj={}
            if(products.length > 0){
                products.map(async (prod)=>{
                    let hsnCode
                    if(prod?.sku?.product_code){
                        await Axios.get(`${process.env.REACT_APP_MASTER_API}/psLineItem/0/${prod?.sku?.product_code}?customerNumber=${LOCAL_STORAGE.customerNo}&userId=${LOCAL_STORAGE.userId}&psCode=PS007`,{
                            headers: {
                                Accept: "application/json",
                                Authorization: `${LOCAL_STORAGE.userToken}`,
                                "Access-Control-Allow-Origin": "*"
                            },
                        }).then((res)=>{
                            hsnCode = res?.data?.resultSet[0].HSNCode
                        })
                    }
                    productObj = {
                        product_code:prod?.sku?.product_code?.toString().toUpperCase(),
                        product_name:prod?.sku?.product_name,
                        product_description : prod?.sku?.product_description,
                        quantity : prod?.quantity,
                        hsn_code : hsnCode
                    }
                    productArray.push(productObj)
                })

                values.products = productArray
                values.numberOfProducts = productArray.length
            }
        }
    }

    return (
        <React.Fragment>
            <AddTitleBar Title='Add E-way bill' LinkName='/ewaybill' />
            <div className="m-2 ui form tiny p-bold-600">
                <Formiker>
                    <Segment>
                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Supply Type"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Dropdown
                                    name="supply_type"
                                    clearable
                                    style={{ width: "100%", fontWeight: "normal" }}
                                    selection
                                    placeholder={
                                        "Select Supply Type"
                                    }
                                    onChange={(name, data) => {
                                        setSupplyTypeValue(data)
                                    }}
                                    options={supplyTypes}
                                    value={values.supply_type}
                                />

                                {errors.supply_type ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.supply_type}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                            <FormUi.Field width={1} />

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Sub Supply Type"}{" "}
                                    <MandatoryMark />

                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Dropdown
                                    name="sub_supply_type"
                                    clearable
                                    style={{ width: "100%", fontWeight: "normal" }}
                                    selection
                                    placeholder={
                                        "Select Sub Supply Type"
                                    }
                                    onChange={(name, data) => {
                                        setFieldValue('sub_supply_type', data.value)
                                        setFieldValue('doc_type', "")
                                    }}
                                    options={subSupplyTypes}
                                    value={values.supply_type ? values.sub_supply_type : ""}
                                />
                                {errors.sub_supply_type ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.sub_supply_type}
                                    </div>
                                ) : null}
                            </FormUi.Field>

                        </FormUi.Group>

                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Document Type"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Dropdown
                                    name="doc_type"
                                    clearable
                                    style={{ width: "100%", fontWeight: "normal" }}
                                    selection
                                    placeholder={
                                        "Select Document Type"
                                    }
                                    onChange={(name, data) => {
                                        setFieldValue('doc_type', data.value)
                                    }}
                                    options={docTypes}
                                    value={values.supply_type && values.sub_supply_type ? values.doc_type : ""}
                                />

                                {errors.doc_type ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.doc_type}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                            <FormUi.Field width={1} />

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Document Number"}{" "}
                                    <MandatoryMark />

                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="doc_no"
                                    component={MyInput}
                                    value={values.doc_no}
                                />
                                {errors.doc_no ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.doc_no}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                        </FormUi.Group>

                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Document Date"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <DatePicker
                                    name="doc_date"
                                    onChange={(date) => {
                                        setFieldValue('doc_date', moment(date).format("YYYY-MM-DD"))
                                    }}
                                    value={values.doc_date ? moment(values.doc_date).format("DD-MM-YYYY") : ""}
                                    customInput={
                                        <Input
                                          className="dateWidth"
                                          icon="calendar alternate outline"
                                          iconPosition="left"
                                        />
                                      }
                                />

                                {errors.doc_date ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.doc_date}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                        </FormUi.Group>

                    </Segment>

                    <Segment>
                        <h6 className="mb-4">Consignor Details</h6>

                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Name"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="from_name"
                                    component={MyConsignorMaster}
                                    value={values.from_name}
                                    placeholder={values.from_trd_name}
                                    nameValue="from_trd_name"
                                    address="from_address_1"
                                    gstNumber="from_gst_no"
                                    cityName="from_city"
                                    cityId="from_cityId"
                                    pincode="from_pincode"
                                />

                                {errors.from_trd_name ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.from_trd_name}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                            <FormUi.Field width={1} />

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Pincode"}{" "}
                                    <MandatoryMark />

                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="from_pincode"
                                    component={MyInput}
                                    value={values.from_pincode}

                                />
                                {errors.from_pincode ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.from_pincode}
                                    </div>
                                ) : null}
                            </FormUi.Field>

                        </FormUi.Group>

                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"City"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="from_cityId"
                                    component={AddCity}
                                    nameValue="from_city"
                                    placeholder={values.from_city || "Select City"}
                                />

                                {errors.from_cityId ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.from_cityId}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"State"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="from_state_code"
                                    component={MyState}
                                    placeholder={"Select state"}
                                />

                                {errors.from_state_code ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.from_state_code}
                                    </div>
                                ) : null}

                            </FormUi.Field>

                        </FormUi.Group>

                        <FormUi.Group>

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Address"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="from_address_1"
                                    component={MyTextArea}
                                    value={values.from_address_1}
                                />

                                {errors.from_address_1 ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.from_address_1}
                                    </div>
                                ) : null}
                            </FormUi.Field>

                            <FormUi.Field width={1} />

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Address 2"}
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="from_address_2"
                                    component={MyTextArea}
                                    value={values.from_address_2}
                                />

                                {errors.from_address_2 ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.from_address_2}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                        </FormUi.Group>

                        <FormUi.Group>

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"GST No"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="from_gst_no"
                                    component={MyInput}
                                    value={values.from_gst_no}
                                />

                                {errors.from_gst_no ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.from_gst_no}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                        </FormUi.Group>

                    </Segment>

                    <Segment>
                        <h6 className="mb-4">Consignee Details</h6>

                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Name"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >

                                <Fieldmik
                                    name="to_name"
                                    component={MyConsigneeMaster}
                                    value={values.to_name}
                                    placeholder={values.to_trd_name}
                                    nameValue="to_trd_name"
                                    address="to_address_1"
                                    gstNumber="to_gst_no"
                                    cityName="to_city"
                                    cityId="to_cityId"
                                    pincode="to_pincode"
                                />

                                {errors.to_trd_name ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.to_trd_name}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Pincode"}{" "}
                                    <MandatoryMark />

                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="to_pincode"
                                    component={MyInput}
                                    value={values.to_pincode}

                                />
                                {errors.to_pincode ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.to_pincode}
                                    </div>
                                ) : null}
                            </FormUi.Field>


                        </FormUi.Group>

                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"City"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="to_cityId"
                                    component={AddCity}
                                    placeholder={values.to_city || "Select City"}
                                    namevalue="to_city"
                                />

                                {errors.to_cityId ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.to_cityId}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"State"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="to_state_code"
                                    component={MyState}
                                    placeholder={"Select state"}
                                />

                                {errors.to_state_code ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.to_state_code}
                                    </div>
                                ) : null}

                            </FormUi.Field>

                        </FormUi.Group>

                        <FormUi.Group>

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Address"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="to_address_1"
                                    component={MyTextArea}
                                    value={values.to_address_1}
                                />

                                {errors.to_address_1 ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.to_address_1}
                                    </div>
                                ) : null}
                            </FormUi.Field>

                            <FormUi.Field width={1} />

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Address 2"}
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="to_address_2"
                                    component={MyTextArea}
                                    value={values.to_address_2}
                                />

                                {errors.to_address_1 ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.to_address_2}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                        </FormUi.Group>

                        <FormUi.Group>

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"GST No"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="to_gst_no"
                                    component={MyInput}
                                    placeholder={"Enter GST No"}
                                    value={values.to_gst_no}
                                />

                                {errors.to_gst_no ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.to_gst_no}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                        </FormUi.Group>

                    </Segment>

                    <Segment>
                        <h6 className="mb-4">Product Details</h6>

                        {values.products.map((productObj, i) => {

                            const productObjErrors = errors.products?.length && errors.products[i] || {};
                            return (
                                <Segment>
                                    <div className="row mb-4 mr-2 ml-1">
                                        <h6>{`Product ${i + 1}`}</h6>
                                        {i > 0 && <Button
                                            onClick={() => { onChangeProductsRemove(values, 'products', setFieldValue, i) }}
                                            className="ml-auto"
                                            basic
                                            size="mini"
                                            type="button"
                                            icon
                                        >
                                            {" "}
                                            <Icon name="trash" color="red" />
                                        </Button>}
                                    </div>
                                    <FormUi.Group>
                                        <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"Product Code"}{" "}
                                                <MandatoryMark />
                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Fieldmik
                                                name={`products[${i}].product_code`}
                                                component={MySkuCode}
                                                id={values.products[i].product_code}
                                                nameValue={`products[${i}].product_name`}
                                                desc={`products[${i}].product_description`}
                                                value={values.products[i].product_code}
                                                
                                            />

                                            {productObjErrors.product_code ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.product_code}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>
                                        <FormUi.Field width={1} />

                                        <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"Product Name"}{" "}
                                                <MandatoryMark />
                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Fieldmik
                                                name={`products[${i}].product_name`}
                                                component={MyInput}
                                                id={values.products[i].product_name}
                                                value={values.products[i].product_name}
                                            />

                                            {productObjErrors.product_name ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.product_name}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>

                                    </FormUi.Group>

                                    <FormUi.Group>
                                        <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"Product Description"}{" "}
                                                <MandatoryMark />

                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Fieldmik
                                                name={`products[${i}].product_description`}
                                                component={MyInput}
                                                id={values.products[i].product_description}
                                                value={values.products[i].product_description}
                                            />
                                            {productObjErrors.product_description ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.product_description}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>
                                        <FormUi.Field width={1} />

                                        <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"HSN Code"}{" "}
                                                <MandatoryMark />
                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Fieldmik
                                                name={`products[${i}].hsn_code`}
                                                component={MyInput}
                                                id={values.products[i].hsn_code}
                                                value={values.products[i].hsn_code}
                                            />

                                            {productObjErrors.hsn_code ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.hsn_code}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>

                                        
                                    </FormUi.Group>

                                    <FormUi.Group>

                                    <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"Quantity"}{" "}
                                                <MandatoryMark />
                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Fieldmik
                                                type="number"
                                                name={`products[${i}].quantity`}
                                                component={MyNumInput}
                                                id={values.products[i].quantity}
                                                value={values.products[i].quantity}
                                            />

                                            {productObjErrors.quantity ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.quantity}
                                                </div>
                                            ) : null}

                                        </FormUi.Field>
                                        <FormUi.Field width={1} />
                                        <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"Unit"}{" "}
                                                <MandatoryMark />
                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Dropdown
                                                name={`products[${i}].qty_unit_id`}
                                                clearable
                                                style={{ width: "100%", fontWeight: "normal" }}
                                                selection
                                                placeholder={
                                                    "Select Unit Of Measurement"
                                                }
                                                onChange={(name, data) => {
                                                    setUnitOfMeasurement(data.value, i)
                                                }}
                                                options={measurementUnits}
                                                id={values.products[i].qty_unit_id}
                                                value={values.products[i].qty_unit_id}
                                            />

                                            {productObjErrors.qty_unit_id ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.qty_unit_id}
                                                </div>
                                            ) : null}

                                        </FormUi.Field>
                                        
                                    </FormUi.Group>

                                    <FormUi.Group>
                                    <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"CGST Rate"}
                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Fieldmik
                                                name={`products[${i}].cgst_rate`}
                                                component={MyNumInput}
                                                type="number"
                                                placeholder={"₹"}
                                                id={values.products[i].cgst_rate}
                                                value={values.products[i].cgst_rate}
                                            />

                                            {productObjErrors.cgst_rate ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.cgst_rate}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>

                                        <FormUi.Field width={1} />

                                        <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"SGST Rate"}
                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Fieldmik
                                                name={`products[${i}].sgst_rate`}
                                                component={MyNumInput}
                                                type="number"
                                                placeholder={"₹"}
                                                id={values.products[i].sgst_rate}
                                                value={values.products[i].sgst_rate}
                                            />

                                            {productObjErrors.sgst_rate ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.sgst_rate}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>

                                       
                                    </FormUi.Group>

                                    <FormUi.Group>
                                    <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"IGST Rate"}
                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Fieldmik
                                                name={`products[${i}].igst_rate`}
                                                component={MyNumInput}
                                                type="number"
                                                placeholder={"₹"}
                                                id={values.products[i].igst_rate}
                                                value={values.products[i].igst_rate}
                                            />

                                            {productObjErrors.igst_rate ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.igst_rate}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>

                                        <FormUi.Field width={1} />

                                        <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"CESS Rate"}
                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Fieldmik
                                                name={`products[${i}].cess_rate`}
                                                component={MyNumInput}
                                                type="number"
                                                placeholder={"₹"}
                                                id={values.products[i].cess_rate}
                                                value={values.products[i].cess_rate}
                                            />

                                            {productObjErrors.cess_rate ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.cesst_rate}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>
                                
                                    </FormUi.Group>

                                    <FormUi.Group>
                                    <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"Non Advol"}
                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Fieldmik
                                                name={`products[${i}].cess_advol`}
                                                component={MyNumInput}
                                                type="number"
                                                placeholder={"₹"}
                                                id={values.products[i].cess_advol}
                                                value={values.products[i].cess_advol}
                                            />

                                            {productObjErrors.cess_advol ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.cess_advol}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>

                                        <FormUi.Field width={1} />

                                        <FormUi.Field width={3}>
                                            <label className="labelName mt-2">
                                                {"Taxable Amount"}{""}
                                                <MandatoryMark />
                                            </label>
                                        </FormUi.Field>
                                        <FormUi.Field
                                            width={4}
                                        >
                                            <Fieldmik
                                                name={`products[${i}].taxable_amount`}
                                                component={MyInput}
                                                type="number"
                                                placeholder={"₹"}
                                                id={values.products[i].taxable_amount}
                                            />

                                            {productObjErrors.taxable_amount ? (
                                                <div className="w3-tiny w3-text-red">
                                                    {productObjErrors.taxable_amount}
                                                </div>
                                            ) : null}
                                        </FormUi.Field>
                                    </FormUi.Group>
                                </Segment>
                            )
                        })
                        }


                        <button class="tiny ui primary basic button" type="button"
                            onClick={(e) => { onChangeProducts(e, values, 'products', setFieldValue) }}
                        >Add Product</button>
                    </Segment>

                    <Segment>

                        <h6 className="mb-4">Transaction Details</h6>


                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Transaction Type"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Dropdown
                                    name="transaction_type"
                                    clearable
                                    style={{ width: "100%", fontWeight: "normal" }}
                                    selection
                                    placeholder={
                                        "Select Transaction Type"
                                    }
                                    onChange={(name, data) => {
                                        setFieldValue('transaction_type', data.value)
                                    }}
                                    options={transactionTypes}
                                    value={values.transaction_type}
                                />

                                {errors.transaction_type ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.transaction_type}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Total Value"}{" "}
                                    <MandatoryMark />

                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    type="number"
                                    name="taxable_amount"
                                    component={MyNumInput}
                                    placeholder={"₹"}
                                />
                                {errors.taxable_amount ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.taxable_amount}
                                    </div>
                                ) : null}
                            </FormUi.Field>


                        </FormUi.Group>

                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"CGST Value"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    type="number"
                                    name="cgst_rate"
                                    component={MyNumInput}
                                    placeholder={"₹"}
                                    value={values.cgst_rate}
                                />

                                {errors.cgst_rate ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.cgst_rate}
                                    </div>
                                ) : null}

                            </FormUi.Field>
                            <FormUi.Field width={1} />
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"SGST Value"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    type="number"
                                    name="sgst_rate"
                                    component={MyNumInput}
                                    placeholder={"₹"}
                                    value={values.sgst_rate}
                                />

                                {errors.sgst_rate ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.sgst_rate}
                                    </div>
                                ) : null}

                            </FormUi.Field>

                        </FormUi.Group>

                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"IGST Value"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="igst_rate"
                                    component={MyNumInput}
                                    type="number"
                                    placeholder={"₹"}
                                    value={values.igst_rate}
                                />

                                {errors.igst_rate ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.igst_rate}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                            <FormUi.Field width={1} />

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"CESS Value"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="cess_rate"
                                    component={MyNumInput}
                                    placeholder={"₹"}
                                    value={values.cess_rate}
                                />

                                {errors.cess_rate ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.cess_rate}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                        </FormUi.Group>

                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Total Invoice Value"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="total_amount"
                                    component={MyInput}
                                    type="number"
                                    placeholder={"₹"}
                                />

                                {errors.total_amount ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.total_amount}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                            <FormUi.Field width={1} />


                        </FormUi.Group>
                    </Segment>



                    <Segment>

                        <h6 className="mb-4">Transporter Details</h6>


                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Transporter Id"}
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="transporter_id"
                                    component={MyInput}
                                    value={values.transporter_id}
                                />

                                {errors.transporter_id ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.transporter_id}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                            <FormUi.Field width={1} />

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Transporter Name"}
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="transporter_name"
                                    component={MyTransporterMaster}
                                    value={values.transporter_name}
                                    gst='transporter_id'
                                />

                                {errors.transporter_name ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.transporter_name}
                                    </div>
                                ) : null}
                            </FormUi.Field>

                        </FormUi.Group>

                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Transportation Distance"}
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="trans_distance"
                                    type="number"
                                    component={MyNumInput}
                                />
                                {errors.trans_distance ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.trans_distance}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                            <FormUi.Field width={1} />

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Transport Document Date"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <DatePicker
                                    name="trans_doc_date"
                                    onChange={(date) => {
                                        setFieldValue('trans_doc_date', moment(date).format("YYYY-MM-DD"))
                                    }}
                                    value={values.trans_doc_date ? moment(values.trans_doc_date).format("DD-MM-YYYY") : ""}
                                    customInput={
                                        <Input
                                          className="dateWidth"
                                          icon="calendar alternate outline"
                                          iconPosition="left"
                                        />
                                      }
                                />

                                {errors.trans_doc_date ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.trans_doc_date}
                                    </div>
                                ) : null}

                            </FormUi.Field>
                        </FormUi.Group>

                        <FormUi.Group>
                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Vehicle Number"}
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Fieldmik
                                    name="vehicle_number"
                                    component={MyVehicleMaster}
                                />

                                {errors.vehicle_number ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.vehicle_number}
                                    </div>
                                ) : null}

                            </FormUi.Field>
                            <FormUi.Field width={1} />

                            <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Vehicle Type"}
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Dropdown
                                    name="vehicle_type"
                                    clearable
                                    style={{ width: "100%", fontWeight: "normal" }}
                                    selection
                                    placeholder={
                                        "Select Vehicle Type"
                                    }
                                    onChange={(name, data) => {
                                        setFieldValue('vehicle_type', data.value)
                                    }}
                                    options={vehicleTypes}
                                    value={values.vehicle_type}
                                />

                                {errors.vehicle_type ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.vehicle_type}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                        </FormUi.Group>
                        
                        <FormUi.Group>
                        <FormUi.Field width={3}>
                                <label className="labelName mt-2">
                                    {"Transportation Mode"}{" "}
                                    <MandatoryMark />
                                </label>
                            </FormUi.Field>
                            <FormUi.Field
                                width={4}
                            >
                                <Dropdown
                                    name="doc_type"
                                    clearable
                                    style={{ width: "100%", fontWeight: "normal" }}
                                    selection
                                    placeholder={
                                        "Select Transportation Mode"
                                    }
                                    onChange={(name, data) => {
                                        setFieldValue('trans_mode', data.value)
                                    }}
                                    options={transModes}
                                    value={values.trans_mode}
                                />

                                {errors.trans_mode ? (
                                    <div className="w3-tiny w3-text-red">
                                        {errors.trans_mode}
                                    </div>
                                ) : null}
                            </FormUi.Field>
                        </FormUi.Group>
                    </Segment>

                    <Container className="p-3" textAlign="center">
                        <button
                            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
                            type="submit"
                            onClick={handleSubmit}
                        >
                            {"Submit"}
                        </button>
                    </Container>
                </Formiker>
            </div>
        </React.Fragment>
    )
}

const FormikEwayBill = withFormik({
    enableReinitialize: false,
    validationSchema: yup.object().shape({
        supply_type: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        sub_supply_type: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        doc_type: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        doc_no: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        doc_date: yup.date(INVALID_FIELDS.INVLAID_DATE).required(REQUIRED_FIELDS.REQUIRED).nullable(),
        from_trd_name: yup.string().required(REQUIRED_FIELDS.REQUIRED).required(REQUIRED_FIELDS.REQUIRED).nullable(),
        from_address_1: yup.string().matches(AllRegex.Address, INVALID_FIELDS.INVALID_ADDRESS).required(REQUIRED_FIELDS.REQUIRED).nullable(),
        from_address_2: yup.string().matches(AllRegex.Address, INVALID_FIELDS.INVALID_ADDRESS).nullable(),
        from_cityId: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        from_pincode: yup.string().matches(AllRegex.Pincode, INVALID_FIELDS.INVALID_PINCODE).required(REQUIRED_FIELDS.REQUIRED).nullable(),
        from_state_code: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        from_gst_no: yup.string().required(REQUIRED_FIELDS.REQUIRED).matches(AllRegex.GSTIN, INVALID_FIELDS.INVALID_GST_NUMBER).nullable(),
        to_trd_name: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        to_address_1: yup.string().required(REQUIRED_FIELDS.REQUIRED).matches(AllRegex.Address, INVALID_FIELDS.INVALID_ADDRESS).nullable(),
        to_address_2: yup.string().matches(AllRegex.Address, INVALID_FIELDS.INVALID_ADDRESS).nullable(),
        to_cityId: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        to_pincode: yup.string().required(REQUIRED_FIELDS.REQUIRED).matches(AllRegex.Pincode, INVALID_FIELDS.INVALID_PINCODE).nullable(),
        to_state_code: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        to_gst_no: yup.string().required(REQUIRED_FIELDS.REQUIRED).matches(AllRegex.GSTIN, INVALID_FIELDS.INVALID_GST_NUMBER).nullable(),
        transaction_type: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        taxable_amount: yup.number().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        cgst_rate: yup.number().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        sgst_rate: yup.number().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        igst_rate: yup.number().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        cess_rate: yup.number().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        total_amount: yup.number().required(REQUIRED_FIELDS.REQUIRED).nullable(),
        transporter_id: yup.string().nullable(),
        transporter_name: yup.string().nullable(),
        trans_distance: yup.number().nullable(),
        trans_doc_date: yup.date(INVALID_FIELDS.INVLAID_DATE).required(REQUIRED_FIELDS.REQUIRED).nullable(),
        vehicle_number: yup.string().matches(AllRegex.VehicleNumber, INVALID_FIELDS.INVALID_VEHICLE_NO).nullable(),
        vehicle_type: yup.string().nullable(),
        trans_mode :  yup.string().nullable(),
        products: yup.array().of(
            yup.object().shape({
                hsn_code: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
                product_name: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
                product_description: yup.string().required(REQUIRED_FIELDS.REQUIRED).nullable(),
                quantity: yup.number().required(REQUIRED_FIELDS.REQUIRED).nullable(),
                qty_unit_id: yup.number().required(REQUIRED_FIELDS.REQUIRED).nullable(),
                cgst_rate: yup.number().nullable(),
                sgst_rate: yup.number().nullable(),
                igst_rate: yup.number().nullable(),
                cess_rate: yup.number().nullable(),
                cess_advol: yup.number().nullable(),
                taxable_amount: yup.number().required(REQUIRED_FIELDS.REQUIRED).nullable()
            },
            )
        )

    }),
    mapPropsToValues: (props) => ({
        supply_type: "I",
        supply_type_id: 1,
        sub_supply_type: 1,
        doc_type: 'INV',
        doc_no: props.history?.location?.state?.invoice_no || '',
        doc_date: props.history?.location?.state?.invoice_date ? moment(props.history.location.state.invoice_date).format("YYYY-MM-DD") : '',
        from_name: "",
        from_trd_name: props.history?.location?.state?.delivery?.consignor?.user_name || '',
        from_address_1: props.history?.location?.state?.delivery?.consignor?.address || '',
        from_address_2: ' ',
        from_cityId: props.history?.location?.state?.delivery?.consignor?.cityMaster?.cityId || '',
        from_city: props.history?.location?.state?.delivery?.consignor?.cityMaster?.cityName || '',
        from_pincode: props.history?.location?.state?.delivery?.consignor?.pincode || '',
        from_state_code: props.history?.location?.state?.delivery?.consignor?.cityMaster?.stateId || '',
        from_gst_no: props.history?.location?.state?.delivery?.consignor?.gstNumber || '',
        to_name: "",
        to_trd_name: props.history?.location?.state?.delivery?.consignee?.user_name || '',
        to_address_1: props.history?.location?.state?.delivery?.consignee?.address || '',
        to_address_2: ' ',
        to_cityId: props.history?.location?.state?.delivery?.consignee?.cityMaster?.cityId || '',
        to_pincode: props.history?.location?.state?.delivery?.consignee?.pincode || '',
        to_state_code: props.history?.location?.state?.delivery?.consignee?.cityMaster?.stateId || '',
        to_gst_no: props.history?.location?.state?.delivery?.consignee?.gstNumber || '',
        numberOfProducts: 1,
        transaction_type: '',
        taxable_amount: '',
        cgst_rate: 0,
        sgst_rate: 0,
        igst_rate: 0,
        cess_rate: 0,
        total_amount: '',
        transporter_id: '',
        transporter_name: '',
        trans_distance: '',
        trans_doc_date: '',
        vehicle_number: '',
        vehicle_type: '',
        trans_mode:"1",
        products: [
            {
                product_code:'',
                hsn_code: '',
                product_name: '',
                product_description: '',
                quantity: '',
                qty_unit_id: '',
                qty_unit_name: "",
                cgst_rate: 0,
                sgst_rate: 0,
                igst_rate: 0,
                cess_rate: 0,
                cess_advol: 0,
                taxable_amount: '',
            }
        ]
    }),

    handleSubmit(values, { setFieldValue, setSubmitting, props }) {
        setSubmitting(true);
        let error = false
        let validationMessage = ''
        //Validation for total amount
        let totalProductAmount = values.products.reduce((prevValue, currentValue) => Number(prevValue) + Number(currentValue.taxable_amount), 0)
        if (Number(totalProductAmount) !== Number(values.total_amount)) {
            error = true
            validationMessage = "The total amount and total amount of the products should be same."
        }
        if (error) {
            cogoToast.error(validationMessage, { position: 'top-right' });
        } else {
            values.supply_type = values.supply_type.toString()
            values.sub_supply_type = values.sub_supply_type.toString()
            values.trans_distance = Number(values.trans_distance)
            values.to_state_code = values.to_state_code.toString()
            values.to_pincode = Number(values.to_pincode)
            values.transaction_type = values.transaction_type.toString()
            const payload = {
                "customer_no": LOCAL_STORAGE.customerNo,
                "user_id": LOCAL_STORAGE.userId,
                act_from_state_code: values.from_state_code,
                act_to_state_code: Number(values.to_state_code),
                ...values
            }
            Axios.post(`${process.env.REACT_APP_TA_API_URL}/Ewaybill/generate`, payload, {
                headers: {
                    Accept: "application/json",
                    Authorization: `${LOCAL_STORAGE.userToken}`,
                    "Access-Control-Allow-Origin": "*"
                },
            }).then((res) => {
                if (res.data.status === 1) {
                    cogoToast.success(res.data.message, { position: "top-right" });
                    window.location.href = '/ewaybill';
                } else {
                    if (res.data.errors) {
                        res.data.errors.map((msg) => {
                            cogoToast.error(`${msg.msg} for ${msg.param}`, {
                                hideAfter: 8,
                                position: "top-right",
                            });
                        })
                    } else if (res.data.data.length > 0) {
                        res.data.data.map((msg) => {
                            let errorObj = Object.values(msg)
                            let errorMsg = ''
                            errorObj.map((err) => {
                                errorMsg += err + " , "
                            })
                            cogoToast.error(errorMsg, { position: 'top-right', heading: res.data.message });
                        })
                    }else{
                        cogoToast.error(res.data.message, { position: 'top-right'});
                    }
                }
            }).catch((error) => {
                error.response.data.message.map((msg) => {
                    cogoToast.error(msg, {
                        hideAfter: 8,
                        position: "top-right",
                    });
                })
            })
        }

    },
})(AddEwayBill);

export default FormikEwayBill;